const isAlertFormElement = function (element) {
    return element.type !== undefined && element.type.indexOf('alert') > -1;
};
export function getFormData(form) {
    let data = {
        fields: {},
        message: ''
    };
    if (form) {
        let dataItems = Array.from(form.querySelectorAll('[name]:not([type="radio"]), [type="radio"]:checked'));
        let validationItems = Array.from(form.querySelectorAll('[name]'));
        let messages = {};
        dataItems.forEach(i => {
            if (i instanceof HTMLInputElement || i instanceof HTMLTextAreaElement || i instanceof HTMLSelectElement) {
                if ("checked" in i && i.type === "checkbox") {
                    data.fields[i.name] = i.checked;
                }
                else {
                    data.fields[i.name] = i.value;
                }
            }
        });
        validationItems.forEach(i => {
            if (i instanceof HTMLInputElement || i instanceof HTMLTextAreaElement || i instanceof HTMLSelectElement) {
                if (!i.checkValidity())
                    messages[i.name] = i.dataset.validationMessage;
            }
        });
        data.message = Object.values(messages).join('<br />');
    }
    return data;
}
export function getFormConfiguration(title, fields, opts) {
    const constructField = (f, i) => {
        switch (f.type) {
            case 'textarea':
                return `
                    <label>${f.label}</label>
                    <textarea
                        class="ui2-input --fill"
                        id="${f.name}"
                        name="${f.name}"
                        tabIndex="${i}"
                        ${f.disabled ? 'disabled' : ''}
                        placeholder="${f.placeholder || ''}"
                        data-validation-message="${f.required ? f.validationMessage || f.label + ' is required' : ''}"
                        ${f.required ? 'required' : ''}
                        rows="${f.rows || 4}"
                        ${f.maxlength ? `maxlength="${f.maxlength}"` : ''}
                        ${f.htmlAttributes || ''}
                    >${f.value != null ? f.value : ''}</textarea>
                `;
            case undefined:
            case 'text':
            case 'number':
            case 'password':
                return `
                    <label>${f.label}</label>
                    <input
                        type="${f.type || 'text'}"
                        class="ui2-input --fill"
                        id="${f.name}"
                        name="${f.name}"
                        value="${f.value != null ? f.value : ''}"
                        autocomplete="off"
                        ${f.maxlength ? `maxlength="${f.maxlength}"` : ''}
                        tabIndex="${i}"
                        ${f.disabled ? 'disabled' : ''}
                        placeholder="${f.placeholder || ''}"
                        data-validation-message="${f.required ? f.validationMessage || f.label + ' is required' : ''}"
                        ${f.required ? 'required' : ''}
                        ${f.htmlAttributes || ''}
                    />
                `;
            case 'select':
                return `
                    ${f.label ? `<label>${f.label}</label>` : ''}
                    <select 
                        class="--fill"
                        id="${f.name}" 
                        name="${f.name}"
                        tabIndex="${i}"
                        ${f.required ? 'required' : ''}
                        ${f.htmlAttributes || ''}
                        >
                        ${f.options.map((o, idx) => `
                            <option value="${o.value}">             ${o.label}       </option>
                        `).join('')}
                    </select>
                `;
            case 'radio':
                return `
                    ${f.label ? `<label>${f.label}</label>` : ''}
                    ${f.options.map((o, idx) => `
                        <div class="radio">
                            <label for="${f.name}_${idx}">
                            <input
                                type="radio"
                                tabIndex="${idx}"
                                name="${f.name}"
                                id="${f.name}_${idx}"
                                value="${o.value}"
                                data-validation-message="${f.required ? f.validationMessage || f.label + ' is required' : ''}"
                                ${f.required ? 'required' : ''}
                                ${o.selected ? 'checked' : ''}
                            >
                            <span>${o.label}</span>
                            </label>
                        </div>
                    `).join('')}
                `;
            case 'div':
                return `<div>${f.label}</div>`;
            default:
                const _exhaustiveCheck = f;
                return _exhaustiveCheck;
        }
    };
    let formHtml = `
        <div class="field-container">
            ${fields.map((f, i) => {
        if (isAlertFormElement(f)) {
            return `
                <div class="alert alert-${f.type.replace('alert-', '')}">
                    <p>
                        ${f.label ? `<strong>${f.label}</strong>` : ''}
                        ${f.text}
                    </p>
                </div>`;
        }
        else {
            return `
                <div class="form-group">
                    ${constructField(f, i)}
                </div>`;
        }
    }).join('')}
        </div>
    `;
    let _opts = Object.assign({}, {
        title,
        hideOnButtonClick: false,
        buttons: {
            CONFIRM: {
                label: 'Submit',
                type: 'success',
                callback: (formData, dialog) => {
                    if (formData.message.length > 0) {
                        dialog.showMessage(formData.message);
                    }
                    else {
                        dialog.hide(formData.fields);
                    }
                }
            }
        },
        body: formHtml
    }, opts);
    return _opts;
}
